import { config } from "../config";
import { useNumberStore } from "../store/number-store";

export const useNumberReachMaxPerTx = (maxNumberPerTx: number) => {
  const numbers = useNumberStore((state) => state.numbers);
  const isReachLimit = numbers.length >= maxNumberPerTx;

  return isReachLimit;
};
